import { QUESTIONNAIRE_STATUS } from '../../../../constants';

export const ACTIVITY_TYPE = {
  ONBOARDING_QUESTIONNAIRE: 'ONBOARDING_QUESTIONNAIRE',
  INTAKE_QUESTIONNAIRE: 'INTAKE_QUESTIONNAIRE',
} as const;

export const ACTIVITY_DATE_FORMAT = 'MM/DD/YY';
export const ACTIVITY_TIME_FORMAT = 'h:mm a';

export const ACTIVITY_STAGE_SEGMENTS = [
  { name: 'notStarted', value: 1 },
  { name: 'pending', value: 1 },
  { name: 'completed', value: 1 },
];

export const ACTIVITY_STAGE_ARC_INNER_RADIUS = 26;
export const ACTIVITY_STAGE_ARC_OUTER_RADIUS = 40;

export const ACTIVITY_STATUS_STAGE = {
  [QUESTIONNAIRE_STATUS.STARTED]: 1,
  [QUESTIONNAIRE_STATUS.IN_PROGRESS]: 2,
  [QUESTIONNAIRE_STATUS.COMPLETED]: 3,
} as const;

export const ACTIVITY_STATUS_LABEL_KEYS = {
  [QUESTIONNAIRE_STATUS.STARTED]: 'activities.status.notStarted',
  [QUESTIONNAIRE_STATUS.IN_PROGRESS]: 'activities.status.pending',
  [QUESTIONNAIRE_STATUS.COMPLETED]: 'activities.status.completed',
} as const;
